import { create } from 'apisauce'


export const isoCtrlAPI = create({
    baseURL: import.meta.env.VITE_APP_TASKDB_BACKEND,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'X-Requested-With',
    },
    timeout: 100000,
})

export const uploadISODataToTask = async (taskId, formData) => {
    isoCtrlAPI.setHeader('Content-Type', 'multipart/form-data')
    const res = await isoCtrlAPI.post(`/importtask/${taskId}`, formData).then((rs) => rs)

    return res
}

export const getGridPreviewForTask = async (taskId, formData) => {
    // add a default max_points=100.000 parameter to the query string to prevent memory issues
    isoCtrlAPI.setHeader('Content-Type', 'multipart/form-data')
    const res = await isoCtrlAPI.post(`/task/${taskId}/grid-preview?max_points=100000`, formData).then((rs) => rs)

    return res
}

export const previewApplicationMapForTask = async (taskId) => {
    // add a default max_points=100.000 parameter to the query string to prevent memory issues
    const res = await isoCtrlAPI.get(`/task/${taskId}/current-application-map?max_points=100000`).then((rs) => rs)

    return res
}
